import { Injectable } from '@angular/core';
import { InfoModalComponent } from './../../test/pages/info-modal/info-modal.component';
import { NgModel } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UIMessage } from './../../shared/helpers/UIMessage';
import swal from 'sweetalert';

@Injectable()
export class CustomMessageService {

  uiMessage : UIMessage = new UIMessage();

  constructor(
    private _infoModal : NgbModal

  ) { }

  info(message: string, title?: string, isHtml?: boolean){
      
  }
  
  success(message: string, title?: string, isHtml?: boolean){

  }
  
  warn(message: string, title?: string, isHtml?: boolean){

  }
  
  error(message: string, title?: string, isHtml?: boolean){

    //console.log("Hasan 1");
    //this.uiMessage.modal.error("", message, null);
    swal(title ? title : '',message,'error');
    //console.log("Hasan 2");
    /*
    //Su anda hatalari gosteren bu modal'de bir yuklenme sorunu var.
    const modalRef = this._infoModal.open(InfoModalComponent);
    
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    */

  }
  
  confirm(message: string, callback?: (result: boolean) => void) {

  }
  
 /*  confirm(message: string, title?: string, callback?: (result: boolean) => void, isHtml?: boolean){
    
  } */

}
